export default __webpack_public_path__ + "static/media/entrega.2fbeb11c.png";